import { PTableCell, PTableRow } from "@porsche-design-system/components-react"
import { Skeleton } from "src/components"
import { NewsListTableHead } from "./NewsListTableHead"

interface NewsListSkeletonProps {
	hasActionColumn?: boolean
	rows?: number
}

export const NewsListSkeleton = ({ hasActionColumn = false, rows = 5 }: NewsListSkeletonProps) => (
	<Skeleton.Table
		caption="News entries"
		tableHead={<NewsListTableHead hasActionColumn={hasActionColumn} />}
		renderCustomRow={(index) => (
			<PTableRow key={index}>
				<PTableCell>
					<Skeleton.Text $width="14rem" />
				</PTableCell>
				<PTableCell>
					<Skeleton.Tag />
				</PTableCell>
				<PTableCell>
					<Skeleton.Text $width="8rem" />
				</PTableCell>
				<PTableCell>
					<Skeleton.Text $width="6rem" />
				</PTableCell>
				<PTableCell>
					<Skeleton.Text $width="6rem" />
				</PTableCell>
				{hasActionColumn && (
					<PTableCell>
						<Skeleton.Text $width="2rem" />
					</PTableCell>
				)}
			</PTableRow>
		)}
		rows={rows}
	/>
)
